import { IFalseNode } from '../QueryNodeTypes';
import { IRegisterableQueryNodeParser } from '../QueryNodeParser';
export class FalseNodeParser implements IRegisterableQueryNodeParser<IFalseNode> {
    type: string = 'false';

    parse(node: IFalseNode): string {
        return `(NOT @uri)`;
    }
}
